import "./styles.scoped.css";
//import screen from "../../images/screen.png";
import { useState, useEffect } from "react";
import terminy from "../../jsondata/terminSpotkania.json";

interface AnimateScreenPros {}

interface Termin {
  dzien: string;
  godzinaRozpoczecia: string;
  godzinaZakonczenia: string;
  tytul: string;
  sala: string
}

const AnimateScreen: React.FC<AnimateScreenPros> = ({}) => {
  const [termin, setTermin] = useState<Termin>();
  const [date, setDate] = useState<Date>();
  useEffect(() => {
    for (let i = 0; i < terminy.length; i++) {
      const tmpTermin: Termin = terminy[i];
      const tmpDate: Date = new Date(tmpTermin.dzien);

      if (tmpDate >= new Date(new Date().toDateString())) {
        setTermin(tmpTermin);
        setDate(tmpDate);
        break;
      }
    }
  }, []);

  return (
    <div className="containferforimg">
      <div className="container">
        <p><span style={{ color: "#6B93DA" }}>C:\TeamBit&gt; Jesteśmy kołem naukowym, które łączy</span></p>
        <p><span style={{ color: "#6B93DA" }}>pasjonatów różnych dziedzin informatyki – </span></p>
        <p>od rozwiązywania problemów logiczno-algorytmicznych po</p>
        <p>pracę z nowoczesnymi technologiami.</p>

        <p><span style={{ color: "#6B93DA" }}>C:\TeamBit&gt; Zainteresowany? skontaktuj się z nami, lub</span></p>
        <p><span style={{ color: "#6B93DA" }}>przyjdź na nasze spotkania, w tym semestrze</span></p>
        <p>
          spotykamy się {termin && date
            ? ` ${(date.getDate() + "").padStart(2, "0")}.${(
                date.getMonth() + 1 + ""
              ).padStart(2, "0")} ${termin.godzinaRozpoczecia} ${termin.sala}`
            : "już wkrótce"}
        </p>
      </div>
    </div>
  );
};

export default AnimateScreen;
